<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-audience"
  [activeStep]="0"
  [error$]="error$"
  [formGroup]="formGroup"
  [sectionTitle]="'activity_creation.audience.section.title' | translate"
  (formSubmit)="submit($event)"
>
  <app-form-control
    [description]="
      'activity_creation.audience.audience.description' | translate
    "
    [title]="'activity_creation.audience.audience.title' | translate"
  >
    <app-form-dropdown
      formControlName="audience"
      [options]="audienceOptions"
    ></app-form-dropdown>
  </app-form-control>
  <div class="organizer-activity-creation-page-audience__age container">
    <app-form-control
      *ngIf="isMinAgeVisible"
      class="col-span-6"
      [label]="'activity_creation.audience.min.label' | translate"
      [errorMessages]="errorMessages('minAge')"
    >
      <app-form-input
        formControlName="minAge"
        [max]="minAgeInputMax"
        [min]="minAgeInputMin"
        [readonly]="minAgeInputReadonly"
        [type]="inputNumberType"
      ></app-form-input>
    </app-form-control>
    <app-form-control
      *ngIf="isMaxAgeVisible"
      class="col-span-6"
      [label]="'activity_creation.audience.max.label' | translate"
      [errorMessages]="errorMessages('maxAge')"
    >
      <app-form-input
        formControlName="maxAge"
        [max]="maxAgeInputMax"
        [min]="maxAgeInputMin"
        [type]="inputNumberType"
      ></app-form-input>
    </app-form-control>
  </div>
  <ul *ngIf="displayProficiencyLevel">
    <li>
      <app-form-checkbox
        formControlName="proficiencyLevelAll"
        [label]="'activity_creation.audience.level.all.label' | translate"
        (change)="changeProficiencyLevelAll()"
      ></app-form-checkbox>
    </li>
    <li>
      <app-form-checkbox-group
        class="block mt-1"
        [checkboxes]="proficiencyLevelCheckboxes"
        formControlName="proficiencyLevels"
        (change)="changeProficiencyLevels()"
      ></app-form-checkbox-group>
    </li>
  </ul>
</app-organizer-shared-form-wrapper>
